import { render } from "./empty.vue?vue&type=template&id=49223b94&scoped=true"
const script = {}

import "./empty.vue?vue&type=style&index=0&id=49223b94&scoped=true&lang=css"

import exportComponent from "/home/test/projects/deploy/frontend/home/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49223b94"]])

export default __exports__